/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { gnoment } from 'shared-ui/gnoment';
import orderBy from 'lodash/orderBy';
import { DATE_FORMAT } from '../../constants';
import type { PermitType, SeasonData } from '../../../types/permit';

export const formatPrice = (value: number) => `$${(value / 100000).toFixed(2)}`;

interface PermitsType {
    permits: Array<PermitType>;
    seasons: Record<string, SeasonData>;
    isLoaded: boolean;
}
export default function Permits({ permits, seasons = {}, isLoaded }: PermitsType) {
    if (!permits || !isLoaded) {
        return null;
    }

    const sortedPermits = orderBy(permits, ['name'], ['asc']);

    const havePermits = permits.length > 0;
    return (
        <div className="tp-permits">
            {havePermits ? (
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Permit Name</th>
                            <th scope="col">Season Dates</th>
                            <th scope="col">Max # Of Trees</th>
                            <th scope="col">Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedPermits?.map((permit) => {
                            const { id, max_trees, name } = permit;
                            const currentSeason = seasons[id];
                            const startDate = gnoment(currentSeason?.start_date).format(
                                DATE_FORMAT
                            );
                            const endDate = gnoment(currentSeason?.end_date).format(
                                DATE_FORMAT
                            );
                            return (
                                <tr key={id}>
                                    <td>{name}</td>
                                    <td>
                                        {startDate} - {endDate}
                                    </td>
                                    <td>{max_trees}</td>
                                    <td>
                                        {formatPrice(currentSeason?.price)} / per tree
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            ) : (
                <p>
                    Fees and season dates for this location are not currently available.
                </p>
            )}
        </div>
    );
}
